export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./hdraces-frame.vue?vue&type=template&id=a13b7456"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/hdraces/hdraces-frame.vue?vue&type=template&id=a13b7456
// module id = 93cI
// module chunks = 0